import type { DentalOfficeShiftCardStatus } from '@tempmee/react-blocks';
import type { TShiftCardData } from '~/types/ShiftCard';
import { computeHours, parseCardDate, resolveProfession } from '~/utils/shiftCard';

/**
 * Minimal shape of an invite-to-existing-shift offer (redux `state.job.recentOpenJobs.offers`).
 * These are the office's own open/action-needed shifts, so there is no assigned professional,
 * rate, or office name to show here — only date / time / profession / status.
 */
export interface IInviteShiftJob {
  id?: string;
  job_status?: string;
  local_date?: string;
  local_start_time?: string;
  local_end_time?: string;
  professionName?: string;
  subProfession?: string | null;
}

const JOB_STATUS_TO_CARD_STATUS: Record<string, DentalOfficeShiftCardStatus> = {
  open: 'open',
  pending: 'confirm-candidates',
  filled: 'scheduled',
};

/**
 * Translates an invite-to-existing-shift offer into props for the DS `DentalOfficeShiftCard`.
 * The card's selection (`selected` / `onCardClick`) is wired by the list, not here.
 */
export const mapInviteJobToShiftCard = (job: IInviteShiftJob): TShiftCardData => ({
  status: (job.job_status ? JOB_STATUS_TO_CARD_STATUS[job.job_status] : undefined) ?? 'open',
  date: parseCardDate(job.local_date),
  startTime: job.local_start_time ?? '',
  endTime: job.local_end_time,
  hours: computeHours(job.local_start_time, job.local_end_time),
  // `professionName` is a display name, `subProfession` a code; resolve to the short code.
  profession: resolveProfession(job.professionName, job.subProfession),
  office: '',
});
